import { translations } from '@aws-amplify/ui-angular';
import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';

import { environment } from '../../../environments/environment';

export function configureAmplify(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: environment.cognito.userPoolId,
        userPoolClientId: environment.cognito.clientId,
      },
    },
  });

  // 組み込み翻訳をベースに、未収録ラベルをカスタム上書きする
  I18n.putVocabularies(translations);
  I18n.setLanguage('ja');
  I18n.putVocabularies({
    ja: {
      'Sign In': 'サインイン',
      'Sign Out': 'サインアウト',
      'Sign in': 'サインイン',
      'Signing in': 'サインイン中',
      Username: 'ユーザー名',
      Password: 'パスワード',
      Email: 'メールアドレス',
      'Enter your Email': 'メールアドレスを入力',
      'Enter your email': 'メールアドレスを入力',
      'Enter your Password': 'パスワードを入力',
      'Enter your password': 'パスワードを入力',
      'Forgot your password?': 'パスワードをお忘れですか？',
      'Reset Password': 'パスワードリセット',
      'Reset your Password': 'パスワードをリセット',
      'Reset your password': 'パスワードをリセット',
      'Back to Sign In': 'サインインに戻る',
      'Send code': '確認コードを送信',
      'Send Code': '確認コードを送信',
      Confirm: '確認',
      Submit: '送信',
      'Change Password': 'パスワード変更',
      'New Password': '新しいパスワード',
      'Confirm Password': 'パスワード確認',
      'Incorrect username or password.':
        'ユーザー名またはパスワードが正しくありません',
      'User does not exist.': 'ユーザーが存在しません',
      'Password must have at least 8 characters':
        'パスワードは8文字以上である必要があります',
      // 確認コード入力欄の汎用訳。MFA / パスワードリセット / TOTP 登録の各画面は
      // signin.page.ts の formFields で画面ごとのラベルに上書きしているため、
      // ここは上書きしていない画面 (属性検証 confirmVerifyUser 等) の
      // フォールバックとして残す (Issue #617)
      Code: '確認コード',
      'Code *': '確認コード *',
      'Confirmation Code': '確認コード',
      'Enter your code': '確認コードを入力',
      // MFA (TOTP) チャレンジ画面 (Issue #213)
      // 組み込み ja 訳が直訳調のため上書きする。セットアップ画面の見出しは
      // signin.page.html の setup-totp-header スロットで手順ごと差し替えている
      'Confirm TOTP Code': 'ワンタイムコードの入力',
      COPY: 'コピー',
      COPIED: 'コピーしました',
    },
  });
}
